import { Outlet } from 'react-router-dom';
import Header from '../landing/Header';
import Footer from '../landing/Footer';
import natureBackground from '../../assets/landing/nature.jpeg';

export default function LandingLayout() {
  return (
    <div className="landing-page min-h-screen flex flex-col">
      {/* Background image with overlay */}
      <div className="fixed inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center bg-fixed"
          style={{ backgroundImage: `url(${natureBackground})` }}
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col min-h-screen">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
